import { SectionHead, Reveal } from "./Reveal";
import { useLang } from "../../i18n/LanguageContext";

export const Markets = () => {
  const { t } = useLang();
  return (
    <section id="markets" className="relative bg-canvas bp-grid py-24 sm:py-32" data-testid="markets-section">
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8">
        <SectionHead eyebrow={t.markets.eyebrow} title={t.markets.title} desc={t.markets.desc} testid="markets" />
        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {t.markets.items.map((m, i) => (
            <Reveal key={m.country} delay={i * 0.1}>
              <article
                data-testid={`market-card-${i}`}
                className="group relative h-full border border-technical bg-white p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_-18px_rgba(22,24,27,0.35)] hover:border-[rgba(122,22,32,0.4)]"
              >
                <div className="flex items-center justify-between">
                  <span className="chamfer-sm bg-red-brand px-3 py-1.5 font-mono-tech text-[10px] font-semibold uppercase tracking-[0.18em] text-[#f8f7f4]">
                    {m.tag}
                  </span>
                  <span className="font-mono-tech text-[10px] tracking-[0.15em] text-[#9ca3af]">{m.coords}</span>
                </div>
                <h3 className="mt-6 font-display text-2xl sm:text-3xl font-extrabold tracking-tight text-ink group-hover:text-red-brand transition-colors duration-300">
                  {m.country}
                </h3>
                <p className="mt-2 font-mono-tech text-[11px] uppercase tracking-[0.18em] text-[#525964]">{m.cities}</p>
                <div className="my-5 h-px w-full bg-[rgba(22,24,27,0.12)]" />
                <p className="text-sm leading-relaxed text-[#525964]">{m.focus}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
